<template>
  <article
    class="form_modal"
    v-if="active_modal">
    <section class="form_modal__container">
      <h1 class="modal_headline_normal__title">Crear nueva categoría</h1>
      <v-flex xs12>
        <span class="table_card__info--label">Nombre</span>
        <input
          class="faccess_input mb-4"
          type="text"
          :style="special_category.attributes.name.length<=0&&activeErrorName?'border:2px solid red !important;background-color:#ef4b4b19':''"
          name="Name"
          @blur="activeErrorName=true"
          placeholder="Nombre de la categoría"
          v-model="special_category.attributes.name">
      </v-flex>

      <v-card class="modal_headline_normal__card mb-2">
        <v-layout row wrap>
          <v-flex xs2
            v-for="icon in icons" :key="icon"
            class="modal_headline_normal__icon"
            :class="{'modal_headline_normal__icon--active': special_category.attributes.icon == icon}"
            @click="special_category.attributes.icon = icon"
          >
            <v-card-title>
              <v-icon>{{icon}}</v-icon>
            </v-card-title>
          </v-flex>
        </v-layout>
      </v-card>

      <div class="modal_headline_normal__buttons">
        <button
          @click="handleCancel"
          class="modal_headline_normal__buttons--closed"> Cerrar</button>
        <button
          @click="formIsInError?'':createSpecialCategory()"
          style="color: #1476FB"
        >Crear</button>
      </div>
    </section>
  </article>
</template>

<script>
// Archivo de datos 'icons.json'
import icons from '../../../vue/resource/icons.json'

export default {
  props:['active_modal'],
  data(){
    return{
      fieldError:'',
      activeErrorName:false,
      special_category:{
        attributes:{
          name: '',
          icon: '',
        }
      },
      poserDialog: false,
      icons: icons
    }
  },
  computed:{
    formIsInError(){
      var ans=false
      let fields=[]
      if(this.special_category.attributes.name.length==0){
        fields.push("'Nombre'");
      }
      if(fields.length>0){
        if(fields.length==2){
          this.fieldError=fields.join(" y ")
        }else{
          this.fieldError=fields.join(" , ")
        }
        ans=true
      }else{
        this.fieldError=""
      }
      return ans
    },
  },
  methods:{
    handleCancel(){
      this.$emit('handleCancelNewSpecialCategory', false)
    },
    createSpecialCategory(){

      try {
        this.$http.post('app/special_categories/create', { data: this.encrypt(this.special_category).toString() },
          {headers:
            {
             "X-Device-ID" : this.getDeviceId(),
             "Authorization" : 'Bearer ' + this.getUserToken()
            }
          })
        .then(function(response){
          console.log(response);
          this.$router.push({name: 'special_categories'})
          this.special_category.attributes.name = '';
          this.special_category.attributes.icon = '';
          this.handleCancel();
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          console.log(response);
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          if(typeof response.body.errors[0].details != "object"){
            alert(response.body.errors[0].details);
          }else{
            let message = []
            for(var key in response.body.errors[0].details){
              message.push(response.body.errors[0].details[key])
            }
            alert(message);
          }
        })
      } catch (e) {
        console.log(e);
        alert(e.message)
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/special_categories/NewSpecialCategory.vue